var $lockMZUpdate = false,
  $firstImageIsVideo = false;

window.HP_prevailVideo = function HP_prevailVideo($video) {
  const videoElement = $video.get(0);

  // Update video src from data-src
  if ($video.attr('data-src')) {
    $video.attr('src', $video.attr('data-src'));
  }

  // Update all source elements from data-src
  $video.find('[data-src]').each(function () {
    const $source = $(this);
    if (!$source.attr('src')) {
      const src = $source.attr('data-src');
      $source.attr('src', src);

      // If it's a <source> tag, set video src as well
      if (this.tagName === 'SOURCE') {
        videoElement.src = src;
      }
    }
  });

  // Ensure autoplay and loop attributes are enabled
  videoElement.autoplay = true;
  videoElement.loop = true;

  // Attempt to play the video, handle autoplay restrictions
  videoElement.play().catch((error) => console.log('Autoplay prevented:', error));

  console.log('play', videoElement);
};

mzOptions = mzOptions || {};
mzOptions.onUpdate = function () {
  if (!$lockMZUpdate) {
    mtHighlightActiveSelector();
  }
  $lockMZUpdate = false;
};
var mtZoomIsReady = false;
mzOptions.onZoomReady = function (id) {
  mtZoomIsReady = true;
  if (!$firstImageIsVideo) {
    mtHighlightActiveSelector();
  }
};

function mtIfZoomReady(fnc) {
  if (!mtZoomIsReady) {
    setTimeout(function () {
      mtIfZoomReady(fnc);
    }, 250);
    return;
  }
  fnc();
}

function mtInitSelectors(selector) {
  //debugger;
  jQuery(selector).on(mzOptions && mzOptions.selectorTrigger && mzOptions.selectorTrigger == 'hover' ? 'mouseover click' : 'click touchend', function (e) {
    var el = jQuery(this);
    var $iframe = jQuery('.active-magic-slide iframe');
    if ($iframe.length == 1) {
      $iframe.attr('src', $iframe.attr('src').replace(/(.*)\?.*/gm, '$1'));
    }
    var $video = jQuery('.active-magic-slide video');
    if ($video.length == 1) {
      $video.stop();
    }
    jQuery('.MagicToolboxContainer .MagicToolboxSlide').removeClass('active-magic-slide');
    jQuery('.MagicToolboxContainer .MagicToolboxSlide[data-slide-id="' + el.attr('data-slide-id') + '"]')
      .addClass('active-magic-slide')
      .removeClass('hidden');
    jQuery('.MagicToolboxContainer .MagicToolboxSelectorsContainer a').removeClass('active-magic-selector mz-thumb-selected');
    el.addClass('active-magic-selector mz-thumb-selected');
    if (el.attr('data-slide-id') == 'spin') {
      var resizeEvent = window.document.createEvent('UIEvents');
      resizeEvent.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(resizeEvent);
    }

    var $iframe = jQuery('.active-magic-slide iframe');
    if ($iframe.length) {
      var $s = $iframe.attr('data-video-options');
      $iframe.attr('src', $iframe.attr('src').replace(/(.*)\?.*/gm, '$1') + '?' + $s);
    }

    e.preventDefault();

    $('.product-detail video:hidden').each(function () {
      $(this).get(0).pause();
    });
    $('.product-detail video:visible').each(function () {
      window.HP_prevailVideo($(this));
    });
  });
}

function mtInitVideoSelectors() {
  jQuery('.MagicToolboxSlides div[data-video-url]').each(function (index) {
    if (jQuery(this).data('processed')) return;

    var regex_youtube_short = /https?:\/\/youtu\.be\/([^\/]{1,})\/?/gm,
      regex_youtube_full = /https?:\/\/www\.youtube\.com\/watch\?v=(.*?)(&|$).*/gm,
      regex_youtube_embed = /https?:\/\/www\.youtube\.com\/embed\/(.{1,})/gm,
      regex_vimeo = /https?:\/\/vimeo\.com\/(.{1,})/gm,
      regex_sproutvideo = /https\:\/\/.*?\.vids\.io\/videos\/(.*?)\/.*/gm,
      regex_sproutvideo2 = /https\:\/\/sproutvideo\.com\/videos\/(.*?)\/*$/gm,
      regex_sproutvideo3 = /https:\/\/[a-z]{1,}.sproutvideo\.com\/embed\/(.*?)\/.*?$/gm,
      video_id,
      video_type;
    var $videoURL = jQuery(this)
      .attr('data-video-url')
      .replace(/https\:\/\/player\.vimeo\.com\/video\/([0-9]{1,})/gm, 'https://vimeo.com/$1');
    var m = regex_youtube_short.exec($videoURL);
    if (m) {
      video_id = m[1];
      video_type = 'youtube';
    } else {
      var m = regex_youtube_full.exec($videoURL);
      if (m) {
        video_id = m[1];
        video_type = 'youtube';
      } else {
        var m = regex_youtube_embed.exec($videoURL);
        if (m) {
          video_id = m[1];
          video_type = 'youtube';
        } else {
          var m = regex_vimeo.exec($videoURL);
          if (m) {
            video_id = m[1];
            video_type = 'vimeo';
          } else {
            var m = regex_sproutvideo.exec($videoURL);

            if (m) {
              video_id = m[1];
              video_type = 'sproutvideo';
            } else {
              var m = regex_sproutvideo2.exec($videoURL);
              if (m) {
                video_id = m[1];
                video_type = 'sproutvideo';
              } else {
                var m = regex_sproutvideo3.exec($videoURL);
                if (m) {
                  video_id = m[1];
                  video_type = 'sproutvideo_embed';
                }
              }
            }
          }
        }
      }
    }
    if (video_type == 'youtube') {
      jQuery(this).html('<div class="magic-video-container"><iframe src="https://www.youtube.com/embed/' + video_id + '" frameborder="0" allowfullscreen></iframe></div>');
    } else if (video_type == 'sproutvideo') {
      jQuery(this).html('<div class="magic-video-container"><iframe src="" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>');

      jQuery.ajax({
        slide_id: jQuery(this).attr('data-slide-id'),
        video_url: $videoURL,
        url: 'https://sproutvideo.com/oembed.json?url=' + 'http://sproutvideo.com/videos/' + video_id,
        crossDomain: true,
        success: function (data, textStatus, jqXHR) {
          jQuery('div[data-slide-id="' + this.slide_id + '"] .magic-video-container').html(data.html);
          var $iframe = jQuery('div[data-slide-id="' + this.slide_id + '"] .magic-video-container').find('iframe');

          var $s = 'autoPlay=true&volume=0&loop=true&background=true';

          $iframe.attr('data-video-options', $s);

          if ($iframe.closest('div').is(':visible') && $s != '') {
            $iframe.attr('src', $iframe.attr('src') + '?' + $s);
          }

          jQuery('a[data-slide-id="' + this.slide_id + '"] img')
            .attr('src', data.thumbnail_url)
            .css('max-width', '100px')
            .closest('a')
            .show();
        },
      });
    } else if (video_type == 'sproutvideo_embed') {
      jQuery(this).html(
        '<div class="magic-video-container"><iframe src="' +
          $videoURL +
          '?autoPlay=true&volume=0&loop=true&background=true" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>'
      );

      jQuery('a[data-slide-id="' + jQuery(this).attr('data-slide-id') + '"] img')
        .closest('a')
        .show();
    } else {
      jQuery('div[data-slide-id="' + jQuery(this).attr('data-slide-id') + '"],a[data-slide-id="' + jQuery(this).attr('data-slide-id') + '"]').remove();
    }
  });
}

function mtHighlightActiveSelector() {
  if (typeof jQuery == 'undefined') {
    return;
  }
  // jQuery('.MagicToolboxContainer .MagicToolboxSelectorsContainer a').removeClass('active-magic-selector');
  // jQuery('.MagicToolboxContainer .MagicToolboxSelectorsContainer a.mz-thumb-selected').addClass('active-magic-selector');

  var $s_item = jQuery('.active-magic-selector').closest('.mcs-item');
  if ($s_item.length) {
    MagicScroll.jump('msc-selectors-container', $s_item.data('item'));
  }
}

function mtGetMaxSizes() {
  var $maxWidth = ($maxHeight = 1);
  jQuery('.MagicToolboxSelectorsContainer a > img').each(function () {
    var img = jQuery(this);
    if (img.is(':visible')) {
      $maxHeight = Math.max($maxHeight, img.height());
      $maxWidth = Math.max($maxWidth, img.width());
    }
  });
  return { width: $maxWidth, height: $maxHeight };
}

function SirvSKUTransform($sku) {
  if (typeof SirvSpinsPathTransform != 'undefined' && SirvSpinsPathTransform != '') {
    var re = new RegExp('^' + SirvSpinsPathTransform + '$', 'gmsi');
    return $sku.replace(re, '$1');
  }
  return $sku;
}

function mtInitSirv() {
  console.warn('x');

  if (typeof SirvID == 'undefined' || SirvID == '') {
    //initMagicScroll();
    return;
  }

  console.warn('x1');

  var spinURL =
    'https://' +
    SirvID +
    '.sirv.com/' +
    SirvSpinsPath.replace(/{product\-id}/g, SirvProductID)
      .replace(/{product\-sku}/g, SirvProductSKU)
      .replace(/{vendor}/g, SirvProductVendor)
      .replace(/{product\-name}/g, SirvProductName);

  console.warn(spinURL);

  if (typeof SirvSpinOverrides != 'undefined' && typeof SirvSpinOverrides[SirvProductID + '-'] != 'undefined' && SirvSpinOverrides[SirvProductID + '-'] != '') {
    spinURL = 'https://' + SirvID + '.sirv.com' + SirvSpinOverrides[SirvProductID + '-'];
  }

  var sirvHandle = spinURL.replace('https://' + SirvID + '.sirv.com/', '');
  if (typeof SirvCache != 'undefined' && typeof SirvCache[sirvHandle] != 'undefined') {
    mtInitSirvIcon(spinURL);
  } else {
    console.warn('x2');
    if (SirvUseCache == 'Yes') {
      initMagicScroll();
    } else {
      jQuery.ajax({
        url: spinURL,
        type: 'HEAD',
        cache: true,
        timeout: 4000,
        error: function (jqXHR, textStatus, errorThrown) {
          initMagicScroll();
        },
        success: function (data, textStatus, jqXHR) {
          console.warn('x2');
          mtInitSirvIcon(spinURL);
        },
      });
    }
  }

  for (var i in SirvVariants) {
    var $sku = SirvSKUTransform(SirvVariantsSKU[i].sku);
    var v_spinURL =
      'https://' +
      SirvID +
      '.sirv.com/' +
      SirvSpinsPath.replace(/{product\-id}/g, i)
        .replace(/{product\-sku}/g, typeof SirvVariantsSKU[i].sku != 'undefined' && SirvVariantsSKU[i].sku != '' && SirvVariantsSKU[i].sku != null ? $sku.replace('/', '') : i)
        .replace(/{vendor}/g, SirvProductVendor)
        .replace(/{product\-name}/g, SirvProductName + '-' + i);

    if (typeof SirvSpinOverrides != 'undefined' && typeof SirvSpinOverrides[SirvProductID + '-' + i] != 'undefined' && SirvSpinOverrides[SirvProductID + '-' + i] != '') {
      v_spinURL = 'https://' + SirvID + '.sirv.com' + SirvSpinOverrides[SirvProductID + '-' + i];
    }

    if (typeof SirvCache != 'undefined' && typeof SirvCache[v_spinURL.replace('https://' + SirvID + '.sirv.com/', '')] != 'undefined') {
      SirvVariants[i] = v_spinURL.replace(/\?callback.*/gm, '');
      if (i == currentVariantID) {
        if (SirvSpinPosition == 'first') {
          mtShowSirvVariant(currentVariantID);
        } else {
          mtInitSirvIcon(SirvVariants[i]);
          var $h = SirvMaxHeight > 0 ? '?h=' + SirvMaxHeight : '';
          jQuery('.Sirv div').attr('data-src', SirvVariants[i] + $h);
        }
        currentVariantID = 0;
      }
    } else {
      if (SirvUseCache == 'Yes') {
        SirvVariants[i] = false;
      } else {
        jQuery.ajax({
          url: v_spinURL,
          type: 'HEAD',
          cache: 'false',
          timeout: 4000,
          spinID: i,
          error: function () {
            SirvVariants[this.spinID] = false;
          },
          success: function (data) {
            SirvVariants[this.spinID] = this.url.replace(/\?callback.*/gm, '');
            if (this.spinID == currentVariantID) {
              if (SirvSpinPosition == 'first') {
                mtShowSirvVariant(currentVariantID);
              } else {
                mtInitSirvIcon(SirvVariants[this.spinID]);
                var $h = SirvMaxHeight > 0 ? '?h=' + SirvMaxHeight : '';
                jQuery('.Sirv div').attr('data-src', SirvVariants[this.spinID] + $h);
              }
              currentVariantID = 0;
            }
          },
        });
      }
    }
  }
}

function initMagicScroll() {
  if (jQuery('#msc-selectors-container').length) {
    //MagicScroll.start();
  }
  //updateMZPGallery({ $id: currentVariantID });
}

function mtInitArrows() {
  jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow').on('click', function (e) {
    var $selectorsContainer = jQuery(this).closest('.MagicToolboxContainer').find('.MagicToolboxSelectorsContainer'),
      $currentSelector = $selectorsContainer.find('a.active-magic-selector'),
      $newSelector = false,
      $useScroll = jQuery('#msc-selectors-container').length,
      $forward = jQuery(this).hasClass('magic-next'),
      $mscItem,
      $mscCurItemId,
      $mscNewItemId;

    if ($useScroll) {
      $mscItem = $currentSelector.parent();
      $mscCurItemId = $mscItem.attr('data-item');
      $mscItem = $forward ? $mscItem.next() : $mscItem.prev();
      if (!$mscItem.length) {
        $mscItem = $selectorsContainer.find('div[data-item=' + $mscCurItemId + ']');
        $mscItem = $forward ? $mscItem.first().next() : $mscItem.last().prev();
        if (!$mscItem.length) {
          //NOTE: carousel, cover-flow
          $mscItem = $forward ? $selectorsContainer.find('.mcs-item:first') : $selectorsContainer.find('.mcs-item:last');
          if (!$mscItem.length) {
            e.preventDefault();
            return;
          }
        }
      }
      $newSelector = $mscItem.find('a');
      $mscNewItemId = $mscItem.attr('data-item');
      $mscNewItemId = parseInt($mscNewItemId, 10);
      MagicScroll.jump('msc-selectors-container', $mscNewItemId);
    } else {
      $newSelector = $forward ? $currentSelector.next('a') : $currentSelector.prev('a');
      if (!$newSelector.length) {
        $newSelector = $forward ? $selectorsContainer.find('a:first') : $selectorsContainer.find('a:last');
      }
    }

    if ($newSelector.length) {
      $newSelector.trigger('click');
      if ($newSelector.hasClass('mz-thumb')) {
        $lockMZUpdate = true;
        MagicZoom.switchTo(jQuery(this).closest('.MagicToolboxContainer').find('a.MagicZoomPlus').attr('id'), $newSelector[0]);
      }
    }
    e.preventDefault();
  });
}

function SirvSetActiveItem(spinURL) {
  // Stop the existing Sirv viewer instance before replacing content
  var $sirvEl = document.getElementById('sirv-spin');
  if ($sirvEl) {
    Sirv.stop($sirvEl);
  }

  // Replace the Sirv container HTML with a fresh div pointing to the new spin URL
  var $container = jQuery('#sirv-spin');
  $container.empty();
  $container.removeAttr('data-sirv-ready').removeAttr('data-sirv-id');
  $container.html('<div data-src="' + spinURL + '"></div>');

  // Reinitialize Sirv on the updated container
  Sirv.start($sirvEl);
}

function mtInitSirvIcon(spinURL) {
  console.warn('mtInitSirvIcon');

  if (jQuery('a[data-slide-id="spin"]').length) {
    return;
  }

  var $iconClass = '';

  if (SirvIconURL == 'gif-overlay' || SirvIconURL == 'giftwitch-overlay') {
    $iconClass = 'spin-overlay-icon';
  }

  if (SirvIconURL == 'gif' || SirvIconURL == 'gif-overlay') {
    SirvIconURL = spinURL + '?image';
  }
  if (SirvIconURL == 'giftwitch' || SirvIconURL == 'giftwitch-overlay') {
    SirvIconURL = spinURL + '?image.rules=R30L60R30&image.speed=1000&image.pause=3000';
  }

  //var $h = (SirvMaxHeight > 0) ? '?h=' + SirvMaxHeight : '';

  //$html = '<div data-src="' + spinURL + $h + '"></div>';

  $instance = Sirv.viewer.getInstance('#sirv-spin');

  SirvSetActiveItem(spinURL);

  jQuery('.MagicToolboxContainer').removeClass('no-thumbnails');
  jQuery('.MagicToolboxSelectorsContainer').show();

  jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow').show();

  var sizes = mtGetMaxSizes();

  if (jQuery('.MagicToolboxSelectorsContainer a').length == 0) {
    jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow').hide();
    jQuery('.MagicToolboxSelectorsContainer').append('<a class="' + $iconClass + '" data-slide-id="spin" href="#"><img id="SirvIcon" src="' + SirvIconURL + '"/></a>');
  } else if (SirvSpinPosition == 'last') {
    jQuery('.MagicToolboxSelectorsContainer a:last').after('<a class="' + $iconClass + '" data-slide-id="spin" href="#"><img id="SirvIcon" src="' + SirvIconURL + '"/></a>');
  } else if (SirvSpinPosition == 'second') {
    jQuery('.MagicToolboxSelectorsContainer a:first').after('<a class="' + $iconClass + '" data-slide-id="spin" href="#"><img id="SirvIcon" src="' + SirvIconURL + '"/></a>');
  } else {
    jQuery('.MagicToolboxSelectorsContainer a:first').before('<a class="' + $iconClass + '" data-slide-id="spin" href="#"><img id="SirvIcon" src="' + SirvIconURL + '"/></a>');
  }

  // if (jQuery('.MagicToolboxContainer').hasClass('layout-bottom')) {
  //     jQuery('#SirvIcon').css('height', sizes.height + 'px').show();
  // } else {
  //     jQuery('#SirvIcon').css('width', sizes.width + 'px').show();
  // }

  mtInitSelectors('.MagicToolboxSelectorsContainer a[data-slide-id="spin"]');

  if (SirvSpinPosition == 'first') {
    if (SirvVariants[currentVariantID]) {
      mtShowSirvVariant(currentVariantID);
      currentVariantID = 0;
    } else {
      jQuery('.MagicToolboxSelectorsContainer a[data-slide-id="spin"]').trigger('click');
    }
  }

  if (jQuery('.MagicToolboxSelectorsContainer a').length == 0) {
    jQuery('.MagicToolboxContainer').addClass('no-thumbnails');
    jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow, .MagicToolboxSelectorsContainer').hide();
    jQuery('div[data-slide-id="zoom"]').removeClass('active-magic-slide');
    jQuery('div[data-slide-id="spin"]').addClass('active-magic-slide');
    Sirv.start();
  }

  initMagicScroll();
}

function mtShowSirvVariant(variant_id) {
  console.warn('mtShowSirvVariant');

  if (jQuery('#SirvIcon').length == 0) {
    var $useScroll = jQuery('#msc-selectors-container').length;
    if ($useScroll) {
      MagicScroll.stop();
    }
    mtInitSirvIcon(SirvVariants[variant_id]);
  }
  if (typeof Sirv != 'undefined') {
    //Sirv.stop();
  }

  var $h = SirvMaxHeight > 0 ? '?h=' + SirvMaxHeight : '';

  //jQuery('div[data-slide-id="spin"]').html('<div class="Sirv" id="sirv-spin"><div data-src="' + SirvVariants[variant_id] + $h + '"></div></div>');

  //var $html = '<div data-src="' + SirvVariants[variant_id] + $h + '"></div>';

  var $instance = Sirv.viewer.getInstance('#sirv-spin'),
    spinURL = SirvVariants[variant_id];

  SirvSetActiveItem(SirvVariants[variant_id]);

  //     if (Sirv.viewer.getInstance('#sirv-spin')) {
  //         Sirv.viewer.getInstance('#sirv-spin').insertItem( $($html).get(0), 0);
  //         Sirv.viewer.getInstance('#sirv-spin').removeItem(1);
  //     } else {

  //         jQuery('div[data-slide-id="spin"]').html('<div class="Sirv" id="sirv-spin">' + $html + '</div>');
  //     }

  if (SirvSpinPosition == 'first') {
    jQuery('a[data-slide-id="spin"]').trigger('click');
  } else {
    jQuery('a.mz-thumb-selected').trigger('click');
  }
}

function mtSwitchImage(largeImage, smallImage) {
  var activeSlide = jQuery('.MagicToolboxContainer .active-magic-slide');
  if (activeSlide.attr('data-slide-id') == 'spin') {
    console.log('activeSlide spin', activeSlide);
    activeSlide.removeClass('active-magic-slide');
    jQuery('.MagicToolboxContainer .MagicToolboxSlide[data-slide-id="zoom"]').addClass('active-magic-slide');
  } else if (activeSlide.clasList.contains('diamond-video-preview')) {
    console.log('activeSlide diamond-video-preview', activeSlide);
  } else {
    console.log('activeSlide', activeSlide);
  }
  if (jQuery('.mz-lens').length == 0) {
    mtHighlightActiveSelector();
    jQuery('a.MagicZoomPlus').attr('href', largeImage);
    jQuery('a.MagicZoomPlus img').first().attr('src', smallImage);
  } else {
    MagicZoom.update(jQuery('a.MagicZoomPlus').attr('id'), largeImage, smallImage);
  }
}

window['MagicjQueryTries'] = 0;

function mtOnDomReady(fnc) {
  if (typeof jQuery == 'undefined') {
    window['MagicjQueryTries']++;
    if (window['MagicjQueryTries'] == 10) {
      var mt_jq = document.createElement('script');
      mt_jq.type = 'text/javascript';
      mt_jq.async = false;
      mt_jq.src = 'https://code.jquery.com/jquery-2.2.4.min.js';
      document.getElementsByTagName('script')[0].parentNode.appendChild(mt_jq);
    }
    setTimeout(function () {
      mtOnDomReady(fnc);
    }, 250);
    return;
  }
  jQuery(document).ready(fnc);
}

function mtGetParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function mtGetVariantId() {
  // Try to get variant from URL
  var variantId = mtGetParameterByName('variant');
  // If not get variants on product object
  if (!variantId && typeof mt_product != 'undefined' && mt_product.variants && mt_product.variants.length > 0) {
    for (var i = 0; i < mt_product.variants.length; i++) {
      if (mt_product.variants[i].available) {
        variantId = mt_product.variants[i].id;
        break;
      }
    }
  }
  return variantId;
}

function updateMZPGallery({ $id, variant }) {
  if (!variant) return console.error('variant is not defined');
  var $containerID = '.MagicScroll';

  if ($('.mzp-clone').length == 0) {
    $($containerID).after('<div style="display:none" class="mzp-clone">' + $($containerID).html() + '</div>');
    $($containerID).html('');
    $('.mzp-clone a').removeAttr('data-zoom-id');
  }

  try {
    MagicZoom.stop();
    MagicScroll.stop();
  } catch (error) {}

  //if (console.log('isLegacyProduct()', isLegacyProduct()));

  if (isLegacyProduct()) {
    var $s = jQuery('.mzp-clone a[data-variants*="' + $id + '"]');
  } else {
    // const imageFileNamePart = imagesHAndlePicker(variant);
    //var $s = $(`div[data-file-name*="${imageFileNamePart}"]`);
    // var $s = jQuery(`.mzp-clone a[data-file-name*="${imageFileNamePart}"]`).first();
    var $s = jQuery('.mzp-clone a[data-variants*="' + $id + '"]');
  }
  //console.log('$s', $s);

  var updateZoom = true;

  if ($s.length == 0) {
    $s = jQuery('.mzp-clone a[data-variants]').first();
    updateZoom = false;
  }

  $($containerID).html('');

  if ($('.mzp-clone a[data-slide-id="spin"]').length) {
    $($containerID).append($('.mzp-clone a[data-slide-id="spin"]').get(0).outerHTML);
  }

  if ($s.get(0)) $($containerID).append($s.get(0).outerHTML);

  if (isLegacyProduct()) {
    controlGalleryForLegacyProducts({ $s, $containerID, $id });
  } else {
    controlGalleryForLegacyProducts({ $s, $containerID, $id });

    // controlGalleryForNewProducts({ $s, $containerID, $id, variant });
  }

  if (updateZoom) {
    $('.mobile-slide .MagicZoomPlus').attr('href', $s.attr('href'));
    $('.mobile-slide .MagicZoomPlus img').attr('src', $s.attr('data-image'));
    $('.mobile-slide .MagicZoomPlus').attr('data-image', $s.attr('data-image'));
  }

  $($containerID + ' a')
    .attr('data-zoom-id', $('.MagicZoomPlus').attr('id'))
    .removeClass('active-magic-selector');

  $($containerID + ' a[data-slide-id="spin"]').removeAttr('data-zoom-id');

  mtInitSelectors($containerID + ' a');

  console.log('mtInitSelectors', $containerID + ' a');
  $mjs(document).jAddEvent('domready', function () {
    console.log('domready');
    setTimeout(function () {
      //console.log('MagicZoom.start()', MagicZoom.start);
      MagicZoom.start();
      MagicScroll.start();
    }, 100);
  });
  //MagicScroll.start();

  /*   // let's select all [data-slide-type="video"] and move them one step up in the DOM
  document.querySelectorAll('[data-slide-type="video"]').forEach(function (videoSlide) {
    videoSlide.parentNode.insertAfter(videoSlide, videoSlide.parentNode.firstChild);
  }); */
}

function controlGalleryForLegacyProducts({ $s, $containerID, $id }) {
  if ($s.length != 0) {
    $('div[data-variants]').addClass('hidden');
    $('div[data-variants*="' + $id + '"]').removeClass('hidden');
  }

  var $hide = false;
  $s.nextAll().each(function () {
    if ($(this).attr('data-variants') != ',') {
      $hide = true;
    }
    if ($hide) {
      //$(this).hide();
    } else {
      $($containerID).append($(this).get(0).outerHTML);
    }
  });

  var $hide = false;
  var $ss = $('div[data-variants*="' + $id + '"]');
  $ss.nextAll().each(function () {
    if ($(this).attr('data-variants') != ',') {
      $hide = true;
    }
    if ($hide) {
      $(this).addClass('hidden');
    } else {
      $(this).removeClass('hidden');
    }
  });

  $('[data-diamond-file="true"]').removeClass('hidden');

  $('.data-MagicZoomPlus:visible').addClass('MagicZoomPlus').removeClass('data-MagicZoomPlus');

  // Move diamond files after first image
  $('.MagicToolboxSlide[data-diamond-file="true"], .js-diamond-desktop-shapes').insertAfter($('.MagicToolboxSlides [data-file-name]:not(.hidden)').eq(0));

  $s.nextAll().each(function () {
    if ($(this).attr('data-diamond-file') === 'true' && this.hasAttribute('data-mobile-diamond-file')) {
      var outerHTML = this.outerHTML;
      // Only append if the container does not already include this outerHTML
      if ($($containerID).html().indexOf(outerHTML) === -1) {
        $($containerID).append(outerHTML);
      }
    }
  });

  // Move mobile diamond files after diamond image
  $(`.MagicZoomPlus--thumb[data-diamond-file="true"][data-mobile-diamond-file],
      a[data-diamond-file="true"][data-mobile-diamond-file]`).insertAfter($('.diamond-image'));

  $($containerID + ' .hidden').removeClass('hidden');
  $($containerID + ' img').removeAttr('loading');
  $('.gallery__inner img[loading]:visible').removeAttr('loading');
}

function controlGalleryForNewProducts({ $s, $containerID, $id, variant }) {
  $('.product-detail video').each(function () {
    $(this).get(0).pause();
  });
  // $containerID >> .MagicScroll
  const imageFileNamePart = imagesHAndlePicker(variant);
  if ($s.length != 0) {
    $('div[data-file-name]').addClass('hidden');
    $('div[data-file-name*="' + imageFileNamePart + '"]').removeClass('hidden');
    $('[data-file-name*="' + imageFileNamePart + '"][data-mobile-diamond-file] img[loading]').removeAttr('loading');
    //$('[data-file-name*="' + imageFileNamePart + '"].data-MagicZoomPlus').addClass('MagicZoomPlus');
  }

  $('.MagicToolboxSlide[data-diamond-file="true"]').removeClass('hidden');
  // sorting desktop
  $('.MagicToolboxSlide[data-diamond-file="true"], .js-diamond-desktop-shapes').insertAfter($('.MagicToolboxSlides [data-file-name]:not(.hidden)').eq(0));

  $(`.MagicZoomPlus--thumb[data-diamond-file="true"][data-mobile-diamond-file],
    a[data-diamond-file="true"][data-mobile-diamond-file]`).insertAfter($('.diamond-image'));

  $s.nextAll().each(function () {
    if ($(this).attr('data-file-name')?.includes(imageFileNamePart) || $(this).attr('data-diamond-file') == 'true') {
      $($containerID).append($(this).get(0).outerHTML);
    }
  });

  // sorting mobile
  $($containerID + ' [data-diamond-file="true"][data-mobile-diamond-file]').insertAfter($($containerID + ' [data-mobile-diamond-file]').eq(0));

  $('[data-file-name*="' + imageFileNamePart + '"]').removeClass('hidden');
  $($containerID + ' .hidden').removeClass('hidden');

  $('.product-detail video:visible').each(function () {
    window.HP_prevailVideo($(this));
  });
}

function imagesHAndlePicker(variant) {
  const shapeCode = getOptionCode('Shape', variant.option1);
  const metalCode = getOptionCode('Metal', variant.option2);
  const imageFileNamePart = `${shapeCode}-${metalCode}`;
  return imageFileNamePart;
}

function isLegacyProduct() {
  const completeRingSettingVariant = document.querySelector('[type="application/json"]#complete-setting-ring-varaint');
  const $options = document.querySelectorAll('.product-detail [data-option-index]');
  const $sizeOption = document.querySelectorAll('.product-detail [data-option-index][data-selector-type="dropdown"][data-option-handle="size"]');
  return $options.length <= 2 && $sizeOption && !completeRingSettingVariant;
}

function getOptionCode(codeFor, value) {
  if (!value) return 'none';
  if (codeFor === 'Shape') {
    const shape = value.toLowerCase();
    switch (shape) {
      case 'radiant':
        return 'RAD';
      case 'elongated cushion':
        return 'ECU';
      case 'emerald':
        return 'EME';
      case 'square cushion':
        return 'SCU';
      case 'oval':
        return 'OVA';
      case 'princess':
        return 'PRI';
      case 'marquise':
        return 'MAR';
      case 'pear':
        return 'PEA';
      case 'cushion':
        return 'SCU';
      case 'round':
        return 'ROU';
      default:
        return ''; // Default empty value if no match
    }
  } else if (codeFor === 'Metal') {
    const metal = value.toLowerCase();
    if (metal.includes('yellow')) {
      return 'Y';
    } else if (metal.includes('white') || metal.includes('platinum')) {
      return 'W';
    } else if (metal.includes('rose')) {
      return 'R';
    } else if (metal.includes('two')) {
      return 'T';
    }
  } else if (codeFor === 'band') {
    const band = value.toLowerCase();

    if (band.includes('diamond')) return 'BD';
  }
  return ''; // Default empty value if no match
}

function initmzp() {
  if (jQuery('#admin_bar_iframe').length) {
    jQuery(document.body).append('<style type="text/css">.mz-zoom-window { margin-top: -' + jQuery('#admin_bar_iframe').height() + 'px; </style>');
  }

  mtInitVideoSelectors('.MagicToolboxSelectorsContainer a');

  mtInitSelectors('.MagicToolboxSelectorsContainer a');

  var $firstVideoSelector = jQuery('[data-slide-num="0"][data-video-url]');
  if ($firstVideoSelector.length) {
    jQuery('a[data-slide-id="' + $firstVideoSelector.attr('data-slide-id') + '"]').trigger('click');
    $firstImageIsVideo = true;
  }

  mtInitSirv();

  mtInitArrows();

  // Debounce function to limit how often a function can be called
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  // Debounced version of the variant change handler
  const debouncedVariantChangeHandler = debounce(function(e) {
    console.warn('variantChanged', e.detail);
    var $id = e?.detail?.variant?.id;
    updateMZPGallery({ $id, variant: e.detail.variant });

    if ((typeof currentVariantID == 'undefined' && !$id) || $id == currentVariantID) return;
    currentVariantID = $id;
    console.warn('currentVariantID', currentVariantID);

    var $s = jQuery('a[data-variants*="' + $id + '"]');
    if (typeof MagicZoom != 'undefined' && $s.length) {
      // MagicZoom.update(
      //     $s.closest('.MagicToolboxContainer').find('.MagicZoomPlus').attr('id'),
      //     $s.attr('href'),
      //     $s.attr('data-image')
      // )
    }

    if (typeof SirvVariants != 'undefined' && typeof SirvVariants[$id] != 'undefined' && typeof SirvVariants[$id] == 'string') {
      mtShowSirvVariant($id);
      $('div[data-slide-id="spin"]').removeClass('hidden');
      //$('div[data-slide-id*="video-"]').removeClass('hidden');
    } else {
      $s.trigger('click');
      $('div[data-slide-id="spin"]').addClass('hidden');
    }
  }, 50); // 50ms debounce time

  // Add the debounced event listener
  document.body.addEventListener('variantChanged', debouncedVariantChangeHandler);

  var fistInput = document.querySelector('input[data-option-val="option1"');
  if (fistInput) {
    fistInput.dispatchEvent(new Event('change', { bubbles: true }));
  } else {
    const completeRingSettingVariant = document.querySelector('[type="application/json"]#complete-setting-ring-varaint');
    const productForm = document.querySelector('.product-form');
    if (completeRingSettingVariant && productForm) {
      const variantJSon = JSON.parse(completeRingSettingVariant.textContent);
      console.log('variantJSon', variantJSon);
      productForm.dispatchEvent(new CustomEvent('variantChanged', { bubbles: true, cancelable: false, detail: { variant: variantJSon } }));
    }
  }

  /*   jQuery('form[action*="/cart/add"]').on('change', function () {

  }); */
}

mtOnDomReady(function () {
  initmzp();
});

// Fix the selector by removing the extra space and add debugging
$(document).on('mouseover', '.mcs-button', function (e) {
  //console.log('mcs-button clicked', e);
  // when windowis ready for animation or for dom mutation, using native frame requestAnimationFrame
  if (window.requestAnimationFrame) {
    requestAnimationFrame(function () {
      window.dispatchEvent(new Event('resize'))
    });
  } else {
    setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 1);
  }
});